import { Box, Typography, Tooltip } from "@mui/material";
function RelevanceScore({ card }) {
  return (
    <Tooltip title="Relevance Score" arrow>
      <Box
        sx={{
          position: "absolute",
          top: 10,
          left: 10,
          backgroundColor: "rgb(105,75,75)",
          borderRadius: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "2px",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          padding: "8px",
          opacity: "0.8",
          cursor: "default",
          // REMOVED pointerEvents: "none" so tooltip works
        }}
      >
        <Typography
          sx={{ color: "white", fontWeight: 600, fontSize: "0.8rem" }}
        >
          {card?.relevanceScore}
        </Typography>
      </Box>
    </Tooltip>
  );
}

export default RelevanceScore;
